exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".base_info .info_list[data-v-0003b8b6]{padding:20px 0}\n", ""]);

// exports
